import { format } from "date-fns";
import moment from "moment";

const formatDateParts = (isoString: any) => {
  const date = new Date(isoString);

  // Extract day, month, and year
  const day = date.getUTCDate();
  const month = date.toLocaleString("en-US", { month: "short" }); // e.g., "Aug"
  const year = date.getUTCFullYear(); // e.g., "2024"

  return { day, month, year };
};

export const FormattedDateRange = ({
  startDate,
  endDate,
}: {
  startDate: any;
  endDate: any;
}) => {
  const start = startDate && formatDateParts(startDate);
  const end = endDate && formatDateParts(endDate);

  return (
    <span className="s-date">
      {start?.day} {start?.month}, {start?.year}
      <span className="divider">-</span>
      {end?.day} {end?.month}, {end?.year}
    </span>
  );
};
